import { parseAccount } from '../../accounts/utils/parseAccount.js';
import { encodeFunctionData, } from '../../utils/abi/encodeFunctionData.js';
import { getContractError } from '../../utils/errors/getContractError.js';
import { estimateGas } from './estimateGas.js';
export async function estimateContractGas(client, { abi, address, args, functionName, ...request }) {
    const account = parseAccount(request.account);
    const data = encodeFunctionData({
        abi,
        args,
        functionName,
    });
    try {
        const gas = await estimateGas(client, {
            data,
            to: address,
            ...request,
        });
        return gas;
    }
    catch (err) {
        throw getContractError(err, {
            abi: abi,
            address,
            args,
            docsPath: '/docs/contract/simulateContract',
            functionName,
            sender: account?.address,
        });
    }
}
//# sourceMappingURL=estimateContractGas.js.map